module.exports = __webpack_public_path__ + "img/6.078c5225.jpg";